import { useEffect, useState } from 'react';
import axios from 'axios';

export const useCurrentCountry = () => {
  const [country, setCountry] = useState(null);

  useEffect(() => {
    const cancelToken = axios.CancelToken.source();

    const getCurrentUserCountry = async () => {
      try {
        const response = await axios.get(
          'https://prod-plus-api.360vuz.com/home?source=api-web-lookup',
          {
            cancelToken: cancelToken.token,
          },
        );

        if (response.data.data) {
          setCountry(response.data.data.country);
        }
      } catch (error) {
        console.error(`Error get current user country: ${error?.message}`);
      }
    };

    getCurrentUserCountry();

    return () => {
      cancelToken.cancel();
    };
  }, []);

  return country;
};
